import axios from 'axios';
import { getValidAccessToken, redirectToLogin, refreshToken } from './api/auth';
import { clearAuthConfig, clearTokens } from './utils/authStorage';
import { useErrorStore } from './utils/authState';

/**
 * Публичный экземпляр axios, не требующий авторизации.
 * Используется, например, для получения конфигурации приложения до инициализации auth.
 */
export const axiosPublic = axios.create();

axios.interceptors.request.use(
  async (config) => {
    const isOAuth = config.url?.includes('/oauth2');
    if (isOAuth) {
      config.headers = config.headers || {};
      config.headers.Authorization = 'Basic dWlfY2xpZW50OnNlY3JldA==';
      return config;
    }

    try {
      const token = await getValidAccessToken();
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      // Не кидаем ошибку, чтобы запрос не зависал
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => {
    if (response.data?.message === null) {
      return {
        ...response,
        data: {
          ...response.data,
          message: 'Действие выполнено',
        },
      };
    }
    return response;
  },
  async (error) => {
    if (!error.config) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    if (error.response?.status === 504) {
      clearAuthConfig();
      clearTokens();
      useErrorStore.getState().setFatalError(true);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await refreshToken();
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        redirectToLogin();
        return Promise.reject(refreshError);
      }
    }

    if (error.response && error.response.status >= 300) {
      const errorData = {
        data: {
          ...error.response.data,
          message: error.response.data?.message,
        },
        status: error.status,
        configParams: error.response.config.params,
      };
      return Promise.reject(errorData);
    }

    return Promise.reject(error);
  },
);

export default axios;
